module.exports = "https://ssr-releases-cdn.paperlesspost.com/_next/static/images/MobileHeroSlat3-3d7b9ce32d75b97b84c9c6fabd70f329.jpg";